// import Insights from "../../Pages/Insights/Insights";

import { PostmortemContextWrapper } from "../context/PostmortemContext";
import UseTourContext from "../context/TourContext";
import React, { Suspense, useEffect, useRef } from "react";
import Loading from "../Components/Loading";
import ChangeTracingLoader from "../Components/Loading/ChangeTracingLoader";
import { Outlet } from "react-router-dom";
import Navbar from "../Components/NavBar/Navbar";
import { TourProvider, useTour } from "@reactour/tour";
import Home from "../Pages/Home/Home";
import PostmortemsPage from "../Pages/PostMortems/Postmortems";
import EditPostmortems from "../Pages/EditPostmortems/EditPostmortems";
import PostmortemReport from "../Pages/PostmortemReport/PostmortemReport";
import DownloadReport from "../Pages/PostmortemReport/DownloadReport";
// import { WebSocketContextWrapper } from "../context/WebSocketContext/WebSocketContext";
import EnsurePageType from "../Components/Redirect/ensurePageType";

const ArchivedPostmortems = React.lazy(() =>
  import("../Pages/ArchivedPostmortems/ArchivedPostmortems")
);

const Create = React.lazy(() => import("../Pages/CreatePostmortem/Create"));

const ChangeTracing = React.lazy(() => import("../Pages/ChangeTracing/ChangeTracing"));

const InsightsDashboard = React.lazy(() => import("../Pages/InsightsDashboard/InsightsDashboard"));

// TourProvider only reads `steps` on mount. Push new steps in and reset to a closed tour at step 0
// (the state a remount used to give) without remounting the whole page.
const TourStepsSync = ({ steps }) => {
  const { setSteps, setCurrentStep, setIsOpen } = useTour();
  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    setIsOpen(false);
    setCurrentStep(0);
    setSteps(steps);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [steps]);
  return null;
};

const App = () => {
  const radius = 10;
  const { currentTouringSteps } = UseTourContext();
  return (
    <TourProvider
      steps={currentTouringSteps}
      styles={{
        popover: (base) => ({
          ...base,
          "--reactour-accent": "#42B0D5",
          borderRadius: radius,
        }),
        maskArea: (base) => ({ ...base, rx: radius }),
        maskWrapper: (base) => ({ ...base, color: "#B5E0F5" }),
        badge: (base) => ({ ...base, left: "auto", right: "-0.8125em" }),
        controls: (base) => ({ ...base, marginTop: 20 }),
        close: (base) => ({ ...base, right: "auto", left: 8, top: 8 }),
        height: "maxContent",
      }}
    >
      <TourStepsSync steps={currentTouringSteps} />
      <div style={{ position: "relative" }}>
        <Navbar />
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </div>
    </TourProvider>
  );
};

export const protectedRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/ongoing-postmortems", element: <PostmortemsPage /> },
      { path: "/archived-postmortems", element: <ArchivedPostmortems /> },
      {
        path: "/editpostmortem",
        element: (
          <PostmortemContextWrapper>
            {/* <WebSocketContextWrapper> */}
              <EnsurePageType requiredPageType="edit" />
              <EditPostmortems />
            {/* </WebSocketContextWrapper> */}
          </PostmortemContextWrapper>
        ),
      },
      {
        path: "/report",
        element: (
          // <WebSocketContextWrapper>
          <>
            <EnsurePageType requiredPageType="report" />
            <PostmortemReport />
            </>
          // </WebSocketContextWrapper>
        ),
      },
      { path: "/download-report", element: <DownloadReport /> },
      { path: "/create", element: <Create /> },
      {
        path: "/change-history",
        element: (
          <Suspense fallback={<ChangeTracingLoader />}>
            <ChangeTracing />
          </Suspense>
        ),
      },
      {
        path: "/insights-dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <InsightsDashboard />
          </Suspense>
        ),
      },
    ],
  },
];
